const Reply = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M5.707 9.99984L8.38909 12.6824C8.58435 12.8776 8.58435 13.1942 8.38909 13.3895C8.21552 13.563 7.9461 13.5823 7.75123 13.4473L7.68198 13.3895L4.11603 9.82067L4.06639 9.74953L4.03875 9.69372L4.01597 9.62609L4.01109 9.60536C4.00383 9.57168 4 9.53647 4 9.50038L4.00546 9.5743L4.0018 9.54286L4.0018 9.45786L4.01679 9.37155L4.03779 9.30934L4.07719 9.23337L4.13169 9.16222L7.68198 5.61129C7.87724 5.41603 8.19383 5.41603 8.38909 5.61129C8.56265 5.78486 8.58194 6.05428 8.44694 6.24915L8.38909 6.3184L5.707 8.99984L10 9.00038C13.5218 9.00038 15.8854 10.9762 15.9959 13.7928L16 14.0004C16 14.2765 15.7761 14.5004 15.5 14.5004C15.2239 14.5004 15 14.2765 15 14.0004C15 11.7272 13.1925 10.0958 10.2615 10.0044L10 10.0004L5.707 9.99984L8.38909 12.6824L5.707 9.99984Z"
      fill="currentColor"
    />
  </svg>
);

export default Reply;
